import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { useTranslation } from "next-i18next";
import { forwardRef, useImperativeHandle, useState } from "react";

export type InfoDialogShowArgs = {
	text: string;
	className?: string;
};

export type InfoDialogHandle = {
	show: (args: InfoDialogShowArgs) => void;
	close: () => void;
};

const InfoDialog = forwardRef<InfoDialogHandle>((_props, ref) => {
	const { t } = useTranslation();

	const [open, setOpen] = useState(false);
	const [options, setOptions] = useState<InfoDialogShowArgs | null>(null);

	// expose imperative API
	useImperativeHandle(
		ref,
		() => ({
			show: (args: InfoDialogShowArgs) => {
				setOptions(args);
				setOpen(true);
			},
			close: () => {
				handleCloseInternal();
			},
		}),
		[],
	);

	const handleCloseInternal = () => {
		setOpen(false);
		setOptions(null);
	};

	const handleOkClick = () => {
		handleCloseInternal();
	};

	return (
		<Dialog
			open={open}
			data-testid="confirmation-dialog"
			aria-describedby="alert-dialog-description"
			className={options?.className}>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">{options?.text}</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button data-testid="ok-button" onClick={handleOkClick}>
					{t("ok")}
				</Button>
			</DialogActions>
		</Dialog>
	);
});

InfoDialog.displayName = "InfoDialog";

export default InfoDialog;
